/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".billing-history-wrapper[_ngcontent-%COMP%]{background-color:#eef6fe;padding-bottom:2rem}.billing-history-wrapper[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{width:100%;height:100vh}"];
export { styles as styles };
//# sourceMappingURL=billing-history.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/billing-history/billing-history.component.scss.shim.ngstyle.js
// module id = 1424
// module chunks = 27 28 29